import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";

function H2({ children }) {
  return (
    <h2 className="mt-10 font-display text-xl font-bold text-ink">{children}</h2>
  );
}

export default function Terms() {
  return (
    <>
      <Seo
        title="Terms of Service | Web Pilot"
        description="The terms for Web Pilot's website design and build, automation setup, and monthly care plan — quotes, billing, cancellation, refunds, and ownership."
      />

      <section className="bg-navy py-16 sm:py-20">
        <div className="mx-auto max-w-6xl px-4 sm:px-6">
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-skyblue">
              Legal
            </p>
            <h1 className="mt-3 font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
              Terms of Service
            </h1>
          </Reveal>
        </div>
      </section>

      <section className="bg-white py-16 sm:py-20">
        <div className="mx-auto max-w-3xl px-4 text-slate-600 sm:px-6">
          <H2>What we sell</H2>
          <p className="mt-3 leading-relaxed">
            Web Pilot sells three things: website design and build, automation
            setup (such as missed-call text-back, online booking, and review
            requests), and a monthly care plan that covers hosting, updates,
            small edits, and automation monitoring.
          </p>

          <H2>Quotes</H2>
          <p className="mt-3 leading-relaxed">
            Every quote is fixed and agreed in writing before any work starts.
            You'll always know the price before you commit. Nothing on this
            website is an offer or a price.
          </p>

          <H2>Billing</H2>
          <p className="mt-3 leading-relaxed">
            The monthly care plan is billed monthly in advance. Website builds
            and automation setups are billed as stated in your written quote.
          </p>

          <H2>Cancellation</H2>
          <p className="mt-3 leading-relaxed">
            Cancel the monthly care plan anytime. Hosting and maintenance
            continue through the end of your current paid billing period.
          </p>

          <H2>Refunds</H2>
          <p className="mt-3 leading-relaxed">
            Full refund of the current month's care plan if the cancellation
            request is received at least 7 days before your next billing date.
            Website build deposits are non-refundable once design work begins.
          </p>

          <H2>What you own</H2>
          <p className="mt-3 leading-relaxed">
            Your domain is registered in your name, and the website and the
            content you provide belong to you.
          </p>

          <H2>Limitation of liability</H2>
          <p className="mt-3 leading-relaxed">
            Web Pilot provides its services "as is." To the fullest extent
            permitted by law, Web Pilot is not liable for indirect,
            incidental, or consequential damages arising from the use of its
            services.
          </p>

          <H2>Governing law</H2>
          <p className="mt-3 leading-relaxed">
            These terms are governed by the laws of the State of Indiana.
          </p>

          <H2>Contact</H2>
          <p className="mt-3 leading-relaxed">
            Questions about these terms? Email{" "}
            <a
              href="mailto:zach@webpilot.agency"
              data-testid="terms-email-link"
              className="text-skyblue underline"
            >
              zach@webpilot.agency
            </a>
            . Web Pilot is operated by Zachary Laboyteaux and serves the
            Indianapolis, Indiana area.
          </p>
        </div>
      </section>
    </>
  );
}
